export default {
  load() {
    $('[data-toggle="menu-responsive"], .menu-responsive-bg .bg-backdrop').click(function(e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).toggleClass('open');
      $('.menu-responsive').toggleClass('open');
      $('body').toggleClass('menu-open');
    });

    $('.sps').each(function() {
      if ($(this).offset().top > $(this).height()) {
        $(this).addClass('sps--blw');
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/util/menu.js